var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7244 4.67917C41.4796 3.77476 41.0023 2.95024 40.3398 2.28771C39.6773 1.62519 38.8528 1.14777 37.9484 0.903C34.6374 0 21.3117 0 21.3117 0C21.3117 0 7.98537 0.0273333 4.67437 0.930333C3.76995 1.17512 2.94544 1.65256 2.28294 2.31512C1.62044 2.97767 1.14307 3.80223 0.898365 4.70667C-0.103135 10.5897 -0.491635 19.554 0.925865 25.2017C1.17059 26.1061 1.64798 26.9306 2.31047 27.5931C2.97297 28.2556 3.79747 28.7331 4.70187 28.9778C8.01287 29.8808 21.3389 29.8808 21.3389 29.8808C21.3389 29.8808 34.6647 29.8808 37.9755 28.9778C38.88 28.7331 39.7045 28.2557 40.367 27.5932C41.0296 26.9306 41.507 26.1061 41.7517 25.2017C42.808 19.3103 43.1335 10.3515 41.7244 4.67917Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0702 21.3433L28.1248 14.9403L17.0702 8.53732V21.3433Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.6667,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4e20e2c24688c2cfcc26513277ffc5ff.svg";
export { ForwardRef as ReactComponent };